// TagPickerValueRenderer.js
import React from "react";

const TagPickerValueRenderer = ({ items }) => {
	// Handle undefined or incorrect items
	if (!Array.isArray(items)) {
		return null;
	}

	// Ensure each item has the label property
	const labels = items
		.filter((item) => item && item.label) // Filter out invalid items
		.map((item) => item.label)
		.join(", ");

	return (
		<span className="rs-picker-toggle-value" id="rs-333-describe" data-testid="picker-describe" style={{ display: "flex", paddingTop: "5px" }}>
			<span className="rs-picker-value-list" title={labels}>
				{items
					.filter((item) => item && item.label) // Ensure valid items are used
					.map((item, index, arr) => (
						<React.Fragment key={item.value}>
							<span className="rs-picker-value-item">{item.label}</span>
							{index < arr.length - 1 && <span className="rs-picker-value-separator">,</span>}
						</React.Fragment>
					))}
			</span>
			<span className="rs-picker-value-count" title={items.length}>
				{items.length}
			</span>
		</span>
	);
};

export default TagPickerValueRenderer;



// WEBPACK FOOTER //
// ./src/components/crm/TagPickerValueRenderer.jsx